import VacancyFillModal from './VacancyFillModal.component';

export default VacancyFillModal;
